<template>
  <v-container>
    <!-- ALERTA DE MENSAGEM -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="3000"
      :color="snackbar.color"
      location="top"
    >
      {{ snackbar.text }}
    </v-snackbar>

    <!-- FORMULÁRIO -->
    <v-card class="mb-5">
      <v-card-title>
        {{ editIndex === null ? 'Criar Nova Mensagem' : 'Editando Mensagem' }}
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="saveMessage">
          <v-text-field
            v-model="form.token"
            label="Token"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.whatsapp"
            label="Número do WhatsApp"
            required
          ></v-text-field>
          <v-textarea
            v-model="form.message"
            label="Mensagem"
            required
          ></v-textarea>
          <v-btn type="submit" :color="editIndex === null ? 'primary' : 'success'">
            {{ editIndex === null ? 'Salvar' : 'Atualizar' }}
          </v-btn>
          <v-btn v-if="editIndex !== null" color="grey" class="ml-2" @click="cancelEdit">
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- LISTA DE MENSAGENS SALVAS -->
    <v-card>
      <v-card-title>
        Mensagens Salvas
      </v-card-title>
      <v-list lines="three">
        <div v-if="messages.length === 0" class="text-center pa-4 text-grey">
          Nenhuma mensagem salva.
        </div>
        <template v-for="(item, index) in messages" :key="index">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong>WhatsApp:</strong> {{ item.whatsapp }}</v-list-item-title>
              <v-list-item-subtitle><strong>Token:</strong> {{ item.token }}</v-list-item-subtitle>
              <v-list-item-subtitle class="mt-2" style="white-space: pre-wrap;">{{ item.message }}</v-list-item-subtitle>
              
              <!-- NOVO: Exibição do status em tempo real -->
              <div class="mt-2" v-if="item.status > 0">
                <v-chip size="small" :color="getStatusColor(item.status)" class="mr-2">
                  <v-icon start :icon="getStatusIcon(item.status)"></v-icon>
                  {{ getStatusText(item.status) }}
                </v-chip>
              </div>

            </v-list-item-content>
            <template v-slot:append>
              <v-btn icon="mdi-pencil" variant="text" color="info" @click="editItem(index)" :disabled="!!item.id"></v-btn>
              <v-btn icon="mdi-delete" variant="text" color="error" @click="deleteItem(index)"></v-btn>
              <!-- Botão de Enviar agora desabilitado após envio para evitar duplicatas -->
              <v-btn color="secondary" class="ml-2" @click="sendMessage(item)" :disabled="!!item.id">Enviar</v-btn>
            </template>
          </v-list-item>
          <v-divider v-if="index < messages.length - 1"></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
// PASSO 1: Importar o cliente do Socket.IO
import { io } from 'socket.io-client';

export default {
  name: 'MessagesPage',
  data() {
    return {
      form: { token: '', whatsapp: '', message: '' },
      messages: [], // Cada item agora terá: { token, whatsapp, message, id, status }
      snackbar: { show: false, text: '', color: 'success' },
      editIndex: null,
      socket: null, // Guardará a nossa conexão WebSocket
    };
  },
  methods: {
    // Carrega mensagens salvas (simulação)
    async loadMessages() {
      try {
        const response = await axios.get('/json/data.json');
        this.messages = response.data.map(m => ({ ...m, id: null, status: 0 }));
      } catch (error) {
        this.messages = [];
        console.warn('Arquivo data.json não encontrado. Iniciando com lista vazia.');
      }
    },
    // Salva ou atualiza a mensagem na lista LOCAL
    saveMessage() {
      if (this.editIndex !== null) {
        Object.assign(this.messages[this.editIndex], this.form);
        this.showSnackbar('Mensagem atualizada!', 'success');
      } else {
        // Adiciona com status inicial 'Aguardando'
        this.messages.push({ ...this.form, id: null, status: 0 });
        this.showSnackbar('Mensagem salva localmente! Clique em "Enviar".', 'info');
      }
      this.cancelEdit();
    },
    // Envia a mensagem para a API e atualiza o ID para rastreamento
    async sendMessage(item) {
      try {
        const { token, whatsapp, message } = item;
        const encodedMessage = encodeURIComponent(message);
        const url = `https://api.lubzap.lubconsulta.com.br/sendzap?token=${token}&whatsapp=${whatsapp}&message=${encodedMessage}`;
        
        const response = await axios.get(url);

        if (response.data && response.data.key && response.data.key.id) {
          item.id = response.data.key.id;   // 👈 ID real da mensagem
          item.status = response.data.status || 'PENDING';

          this.showSnackbar('Mensagem enviada com sucesso!', 'success');
        } else {
          throw new Error('Resposta inesperada da API');
        }

      } catch (error) {
        this.showSnackbar(error.message, 'error');
      }
    },
    // Métodos de edição e exclusão (sem grandes mudanças)
    editItem(index) {
      this.editIndex = index;
      this.form = { ...this.messages[index] };
    },
    deleteItem(index) {
      this.messages.splice(index, 1);
      this.showSnackbar('Mensagem excluída!', 'warning');
    },
    cancelEdit() {
      this.editIndex = null;
      this.form = { token: '', whatsapp: '', message: '' };
    },
    showSnackbar(text, color = 'success') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    // Métodos auxiliares para exibir o status na tela
    getStatusText(status) {
      const statuses = {
        0: 'Aguardando',
        1: 'Enviado',
        2: 'Entregue',
        3: 'Lido',
        4: 'Reproduzido'
      };
      return statuses[status] || 'Erro/Desconhecido';
    },
    getStatusColor(status) {
      const colors = {
        0: 'grey',
        1: 'blue',
        2: 'orange',
        3: 'success',
        4: 'deep-purple-accent-1' // Uma cor roxa do Vuetify
      };
      return colors[status] || 'error'; 
    },
    getStatusIcon(status) {
      const icons = {
        1: 'mdi-check',
        2: 'mdi-check-all',
        3: 'mdi-check-all', // O ícone é o mesmo, a cor muda
        4: 'mdi-microphone'
      };
      return icons[status] || 'mdi-alert-circle-outline';
    }
  },
  // PASSO 2: Conectar ao WebSocket quando o componente for criado
  created() {
    this.loadMessages();

    // Conecta ao backend
  this.socket = io('https://api.lubzap.lubconsulta.com.br', {
    path: '/socket.io',
    transports: ['websocket'],
  });

  this.socket.on('connect', () => {
    console.log('🔌 Socket conectado:', this.socket.id);

    // Assina canal global autenticado por bearer
      this.socket.emit('subscribe_bearer', {
        authorization: `Bearer WrHX9dvcvKU601eJ_SJypi_qHzMPkRgVo5KUbR39o-KmXjY6tZMWI9LW_4l8Q6Me`,
        // ou: token: this.bearerToken
      });
    });

    // Recebe update de status de qualquer sessão
    this.socket.on('status_update', (data) => {
      console.log('✅ Update de status recebido:', data);

      const msg = this.messages.find((m) => m.id === data.messageId);
      if (!msg) return;

      msg.status = data.status;
      this.showSnackbar(
        `Mensagem para ${msg.whatsapp} foi ${this.getStatusText(data.status).toLowerCase()}!`,
        this.getStatusColor(data.status),
      );
    });

    this.socket.on('connect', () => {
        console.log('🔌 Conectado ao servidor WebSocket!');
    });
  },
  // PASSO 3: Desconectar quando o componente for destruído (boa prática)
  beforeUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
};
</script>